import { css, styled } from 'styled-components';

export const Container = styled.div(
  ({ theme }) => css`
    font-family: ${theme.fonts};
    flex: 1;
  `,
);
